import { Listing } from '../../gql/graphql';
import { ITEM_WITH_SLUG_ROUTE } from '../../url_helpers';

export function listingItemPageMetaDataUrl(listing: Listing): string {
  const { id, slug } = listing;

  return `https://reverb.com${ITEM_WITH_SLUG_ROUTE.expand({ id, slug })}`;
}
